import axios from 'axios'

async function get_results(email,setResults,token){

try{

  const data = {
    email:email
  }

  // console.log(token)

  const getResults = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}get-results/`,data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{console.log(err)})

  if (getResults?.status == 200 && getResults?.data.success == true) {
  
    setResults(getResults?.data.results)
  }
}catch(err){
  console.log(err)
}
}

export default get_results